<div class="grid grid-cols-1 sm:grid-cols-1 w-full mt-2 p-10">
  <ng-container>
    <mat-accordion>
      <mat-expansion-panel
        class="mb-3"
        (opened)="panelOpenState = true"
        (closed)="panelOpenState = false"
      >
        <mat-expansion-panel-header>
          <mat-panel-title class="tprimary">
            <span class="flex items-center">
              <mat-icon [svgIcon]="'mat_outline:timer_off'"></mat-icon>
              <b class="ml-2">Session Timeout Settings</b></span
            >
          </mat-panel-title>
          <mat-panel-description>
            Set session/idle timeout.
          </mat-panel-description>
        </mat-expansion-panel-header>
        <ng-container>
          <div class="grid grid-cols-4 gap-4">
            <mat-form-field class="w-full mb-4">
              <mat-label>Idle Timeout</mat-label>
              <input
                matInput
                type="number"
                placeholder="If Idle for 30 minutes"
                required
                name="timeout"
                matTooltip="Enter timeout in minutes"
                class="hover:border-blue-500 focus:border-blue-500 transition duration-300"
              />
            </mat-form-field>
            <mat-form-field class="w-full mb-4">
              <mat-label>Waiting Time</mat-label>
              <input
                matInput
                type="number"
                placeholder="wait for another 1 minutes"
                required
                name="timeout"
                matTooltip="If Idle reached, countdown time in minutes"
                class="hover:border-blue-500 focus:border-blue-500 transition duration-300"
              />
            </mat-form-field>
            <mat-form-field class="w-full mb-4">
              <mat-label>Logout Time</mat-label>
              <input
                matInput
                type="number"
                placeholder="and logout in 31 minutes."
                required
                name="timeout"
                matTooltip="Logout, If not active for 31 m"
                class="hover:border-blue-500 focus:border-blue-500 transition duration-300"
              />
            </mat-form-field>
            <button
              class="ml-2 w-30 mt-5"
              mat-flat-button
              [color]="'primary'"
              appPreventMultiClick
              [matTooltip]="'Update'"
            >
              Update
            </button>
          </div>
        </ng-container>
      </mat-expansion-panel>
      <mat-expansion-panel
        class="mb-3"
        (opened)="panelOpenState = true"
        (closed)="panelOpenState = false"
      >
        <mat-expansion-panel-header>
          <mat-panel-title class="tprimary">
            <span class="flex items-center">
              <mat-icon [svgIcon]="'mat_outline:upload_file'"></mat-icon>
              <b class="ml-2">Upload Paid Partners</b></span
            >
          </mat-panel-title>
          <mat-panel-description> Upload paid partners. </mat-panel-description>
        </mat-expansion-panel-header>
        <ng-container>
          <div class="w-full">
            <mat-card class="p-6 mb-4">
              <mat-card-title class="text-2xl font-bold mb-4"
                >File Upload</mat-card-title
              >
              <div class="mb-4">
                <input type="file" class="hidden" id="fileInput" />
                <label
                  for="fileInput"
                  class="cursor-pointer bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded inline-block"
                >
                  Choose File
                </label>
                <!-- <span class="ml-2">Selected File: {{ selectedFile.name }}</span> -->
              </div>
            </mat-card>
            <button
              class="ml-2 w-30 mt-2"
              mat-flat-button
              [color]="'primary'"
              appPreventMultiClick
              [matTooltip]="'Save'"
            >
              Save
            </button>
          </div>
        </ng-container>
      </mat-expansion-panel>
    </mat-accordion>
  </ng-container>
</div>
